import React from 'react';

import { Icon } from '@chakra-ui/react';

export const MaskIcon = props => (
  <Icon viewBox="0 0 24 24" color="inherit" h="full" w="full" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.254 13.9749V17H12.754V13.9672C14.2271 13.846 15.6039 13.3931 16.8015 12.6851L18.3545 15.375L19.6535 14.625L18.0318 11.816C19.1746 10.8606 20.1061 9.61996 20.6917 8.2749L19.3164 7.67617C18.7623 8.94881 17.8318 10.1208 16.7002 10.9556C16.673 10.9757 16.6456 10.9957 16.618 11.0155C15.3326 11.9381 13.7363 12.4901 12.0009 12.4999C12.0006 12.4999 12.0002 12.4999 11.9999 12.4999L11.9542 12.5C11.9538 12.5 11.9535 12.5 11.9532 12.5C10.229 12.4998 8.64029 11.9643 7.35483 11.0613C6.16376 10.2246 5.23552 9.07427 4.69969 7.74421L3.30835 8.30472C3.87054 9.70022 4.7854 10.922 5.94395 11.872L4.3545 14.625L5.65354 15.375L7.18138 12.7287C8.38861 13.4274 9.77393 13.8685 11.254 13.9749Z"
      fill="currentColor"
    />
  </Icon>
);
